import React, { useEffect, useState } from "react";
import Footer from "../../../components/footer";
import Navbar from "../../../components/nav/public-navbar";



import { API } from "../../../constants";
import { getReq } from "../../../apis/internalApi";
import { pickRandomCalendlyLink } from "../../../helpers/chanceMethods";
import Testimonials from "./testimonials";
import "../public-pages.css"

import ProblemSolution from "./problem-solution";
import Mission from "./Mission";
import Hero from "./Hero";
import NoMore from "./NoMore";
import GetStartedNow from "./GetStartedNow";
import CalculatorCTA from "./CalculatorCTA";
import Freebie from "./Freebie";
import EndCTA from "./EndCTA";
import Pricing from "./Pricing";
import TestimonialTitle from "./TestimonialTitle";

const PubHomePage = () => {
  const [link, setLink] = useState(null);

  useEffect(() => {
    const asyncEffect = async () => {
      try {
        const response = await getReq(API.PROSPECT_ASSIGNMENT, "index", "");
        setLink(pickRandomCalendlyLink(response.data))
      } catch (error) { }
    };
    asyncEffect();
  }, []);

  return (

    <div className="bg-white">

      <Navbar />
      <Hero />
      <Mission />
      <ProblemSolution />
      <GetStartedNow />
      <TestimonialTitle />
      <Testimonials />
      <Pricing link={link} />
      <NoMore link={link} />

      <CalculatorCTA />
      <Freebie />
      <EndCTA link={link} />
      <Footer />
    </div>
  );
};


export default PubHomePage;
